import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'

const DIR = 'account/modules'

const state = {
    modulesPanels: [],
    modulesPanelDetails: [],
    showChangeModulStatusDialog: false,
    changeModulStatusDialogText: '',
    selectedModul: {},

    // Panel Details
    svWorkRegistrationModulePanelDetails: [],
    cwrExportModulePanelDetails: [],
    ndaSupportModulePanelDetails: [],
    alvVaultModulePanelDetails: [],
    digitalDistributionModulePanelDetails: [],
}

const getters = {
    getModulesPanels(state) { return state.modulesPanels },
    // getModulesPanelDetails(state) { return state.modulesPanelDetails },
    getShowChangeModulStatusDialog(state) { return state.showChangeModulStatusDialog },
    getChangeModulStatusDialogText(state) { return state.changeModulStatusDialogText },
    getSelectedModul(state) { return state.selectedModul },

    // Panel Details
    getSvWorkRegistrationModulePanelDetails(state) { return state.svWorkRegistrationModulePanelDetails},
    getCwrExportModulePanelDetails(state) { return state.cwrExportModulePanelDetails },
    getNdaSupportModulePanelDetails(state) { return state.ndaSupportModulePanelDetails },
    getAlvVaultModulePanelDetails(state) { return state.alvVaultModulePanelDetails },
    getDigitalDistributionModulePanelDetails(state) {return state.digitalDistributionModulePanelDetails },
}

const mutations = { 
    setModulesPanels: (state, modulesPanels) => { state.modulesPanels = modulesPanels },
    // setModulesPanelDetails: (state, details) => { state.modulesPanelDetails.push(details) },
    setShowChangeModulStatusDialog: (state, show) => { state.showChangeModulStatusDialog = show },
    setChangeModulStatusDialogText: (state, text) => { state.changeModulStatusDialogText = text },
    setSelectedModul: (state, modul) => { state.selectedModul =  modul},

    // Panel Details
    setSvWorkRegistrationModulePanelDetails: (state, details) => { state.svWorkRegistrationModulePanelDetails = details },
    setCwrExportModulePanelDetails: (state, details) => { state.cwrExportModulePanelDetails = details },
    setNdaSupportModulePanelDetails: (state, details) => { state.ndaSupportModulePanelDetails = details },
    setAlvVaultModulePanelDetails: (state, details) => { state.alvVaultModulePanelDetails = details },
    setDigitalDistributionModulePanelDetails: (state, details) => { state.digitalDistributionModulePanelDetails = details },
}

const actions = {
    // FETCH PANELS
    async fetchModulesPanels( { commit, dispatch, getters }) {  
        let response = await api.getListData(DIR)

        commit('setModulesPanels', response.list)

        dispatch('fetchSvWorkRegistrationModulePanelDetails')
        dispatch('fetchCwrExportModulePanelDetails')
        dispatch('fetchNdaSupportModulePanelDetails')
        dispatch('fetchAlvVaultModulePanelDetails')
        dispatch('fetchDigitalDistributionModulePanelDetails')

        // response.list.forEach(panel => {
        //     dispatch('fetchPanelDetails', { alvId: panel['alvId'] })
        // })
    },

    // async fetchPanelDetails({ getters, commit }, params ) {
    //     let details = await api.getDetailsById(DIR, params['alvId'])
    //     commit('setModulesPanelDetails', details)
    // },

    // Panel Details Fetch Calls
    async fetchSvWorkRegistrationModulePanelDetails({ getters, commit }) {
        let panels = getters.getModulesPanels
        let panelAlvId = panels.find(panel => {
            return panel.moduleName === "sv_work_registration"
        }).alvId
        
        let details = await api.getDetailsById(DIR, panelAlvId)
        commit('setSvWorkRegistrationModulePanelDetails', details)
    },

    async fetchCwrExportModulePanelDetails({ getters, commit }) {
        let panels = getters.getModulesPanels
        let panelAlvId = panels.find(panel => {
            return panel.moduleName === "cwr_export"
        }).alvId
        
        let details = await api.getDetailsById(DIR, panelAlvId)
        commit('setCwrExportModulePanelDetails', details)
    },

    async fetchNdaSupportModulePanelDetails({ getters, commit }) {
        let panels = getters.getModulesPanels
        let panelAlvId = panels.find(panel => {
            return panel.moduleName === "nda_partner"
        }).alvId
        
        let details = await api.getDetailsById(DIR, panelAlvId)
        commit('setNdaSupportModulePanelDetails', details)
    },

    async fetchAlvVaultModulePanelDetails({ getters, commit }) {
        let panels = getters.getModulesPanels
        let panelAlvId = panels.find(panel => {
            return panel.moduleName === "alv_vault"
        }).alvId
        
        let details = await api.getDetailsById(DIR, panelAlvId)
        commit('setAlvVaultModulePanelDetails', details)
    },

    async fetchDigitalDistributionModulePanelDetails({ getters, commit }) {
        let panels = getters.getModulesPanels
        let panelAlvId = panels.find(panel => {
            return panel.moduleName === "digital-distribution"
        }).alvId
        
        let details = await api.getDetailsById(DIR, panelAlvId)
        commit('setDigitalDistributionModulePanelDetails', details)
    },

    // SAVE
    async saveModule({ getters, commit, dispatch }) {
        let alvId = getters.getSelectedModul.alvId
        let selectedModul = getters.getSelectedModul

        // Prepare meta data
        let metaData = {
            'status' : selectedModul['status'] === true ? selectedModul['status'] = 1 : selectedModul['status'] = 0,
        }

        if(selectedModul.selectedStorageOption !== null) {
            metaData['selectedStorageOption'] = selectedModul.selectedStorageOption
        }

        let response = await api.saveEditForm(DIR, alvId, metaData, '')

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []

            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'), // TODO: better message for user
            })
            
            
            getters.getSelectedModul.status = !getters.getSelectedModul.status

        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t(response.response.txt)
            })
        }

        // refresh data
        dispatch('fetchModulesPanels')
        if(getters.getSelectedModul.status === 1) getters.getSelectedModul.disabled === true
        commit('setSelectedModul', {})
    }
}

export default {
    state, getters, actions, mutations
}